import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { TemplateCardComponent } from '@shared/components/template-picker-dialog/template-card/template-card.component';
import { TemplatePickerDialogComponent } from '@shared/components/template-picker-dialog/template-picker-dialog.component';
import { SimulationTemplateCardComponent } from './simulation-template-card/simulation-template-card.component';

@NgModule({
    declarations: [
        TemplateCardComponent,
        SimulationTemplateCardComponent,
        TemplatePickerDialogComponent
    ],
    imports: [
        SharedModule,
        RouterModule,
    ]
})
export class TemplatePickerDialogModule { }
